import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { useNotificationStore } from '@/common';
import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { SelectBranchReq, SelectBranchRes } from './types';

const selectBranch = (
  payload: SelectBranchReq
): Promise<BaseResponse<SelectBranchRes, SelectBranchReq>> => {
  return axios<
    SelectBranchReq,
    BaseResponse<SelectBranchRes, SelectBranchReq>,
    SelectBranchReq
  >({
    url: '/branch-crm',
    method: 'post',
    data: {
      ...payload,
    },
  });
};

export const useSelectBranch = () => {
  const { addNotification } = useNotificationStore();
  const { mutateAsync, error } = useMutation({
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'Success',
      });
    },
    mutationFn: selectBranch,
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { selectBranch: mutateAsync };
};
